import { Outlet } from 'react-router-dom';

export const DevKitModule: React.FC = () => {
  return <Outlet />;
};
